module.exports = window.wp.primitives;